import {ActionType} from '../../enums/action-type.enum';
import {FrameService} from '../../modules/shared/services/frame.service';
import {Store} from '@ngrx/store';
import VideoState from '../../modules/shared/stores/root-store/video.state';

export abstract class ActionAbstract {
    private readonly type: ActionType;

    protected constructor(type) {
        this.type = type;
    }

    public getType() {
        return this.type;
    }

    public abstract getFrameToPerform(frameService: FrameService);

    public abstract performAction(store: Store<{ video: VideoState }>, frameService?: FrameService);
}
